import { HTMLAttributes, SVGProps } from 'react';
import { Typography } from '../typography/typography';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from '@tanstack/react-router';
import { FeaturedIcon } from '../featuredIcon/featuredIcon';
import { IconStar } from '@maia/icons';

export type PageHeaderTitleProps = {
  title?: string;
  icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  reference?: string;
  description?: string;
  isSpecialLimit?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export function PageHeaderTitle(props: PageHeaderTitleProps) {
  const {
    title,
    icon: Icon,
    reference,
    className,
    description,
    isSpecialLimit,
    ...rest
  } = props;

  return (
    <div className={twMerge('flex flex-col gap-y-12', className)} {...rest}>
      <div className="flex flex-row space-x-12 items-center">
        <div className="flex flex-row space-x-8 items-center">
          {Icon && <Icon className="min-w-24 w-24 h-24 fill-primaryMain" />}
          {title && (
            <Typography
              variant="display6"
              weight="semibold"
              className="text-primaryMain"
            >
              {title}
            </Typography>
          )}
        </div>

        {reference && (
          <Typography
            variant="display6"
            weight="semibold"
            className="text-primary200"
          >
            {reference}
          </Typography>
        )}
        {isSpecialLimit && (
          <FeaturedIcon
            icon={<IconStar />}
            variant="light-circle"
            color="warning"
            size="sm"
          />
        )}
      </div>

      {description && (
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400"
        >
          {description}
        </Typography>
      )}
    </div>
  );
}
